import React from 'react';
export function GuaranteeSection() {
  return <section className="max-w-2xl mx-auto text-center" data-id="element-215">
      <div data-id="element-216">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-217">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#A855F7] mb-4" data-id="element-218">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="bg-[#0d0818] border-2 border-[#A855F7] rounded-2xl p-8 mb-6" data-id="element-219">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-220">
            Abrís los tomos. Los usás en el estudio.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-221">
            Si en 7 días no es exactamente lo que esperabas:
          </p>
          <p className="text-[#A855F7] text-3xl font-black mb-4" data-id="element-222">
            devolución del 100%
          </p>
          <p className="text-white text-xl font-bold" data-id="element-223">
            sin formularios, sin drama, sin explicaciones.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-224">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </section>;
}